import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import Table from "components/Table";
import Columns from "./Columns";
import { getCoinHistoryList } from "store/settings/actions";
import usePermission from "hooks/usePermission";
import FormikForm from "components/shared/FormikForm";
import moment from "moment";

const InputFieldsForSearch = [
  {
    name: "datepicker",
    type: "datepicker",
    label: "",
    placeholder: "",
  },
  {
    name: "line",
    type: "select",
    label: "",
    placeholder: "Select Line Number...",
    options: [
      { label: "1", value: "1" },
      { label: "2", value: "2" },
      { label: "3", value: "3" },
      { label: "4", value: "4" },
      { label: "5", value: "5" },
      { label: "6", value: "6" },
      { label: "7", value: "7" },
      { label: "8", value: "8" },
      { label: "9", value: "9" },
      { label: "10", value: "10" },
      { label: "11", value: "11" },
      { label: "12", value: "12" },
      { label: "13", value: "13" },
      { label: "14", value: "14" },
      { label: "15", value: "15" },
    ],
  },
  {
    name: "status",
    type: "select",
    label: "",
    placeholder: "Select Status...",
    options: [
      { label: "All", value: "" },
      { label: "Enabled", value: "enabled" },
      { label: "Disabled", value: "disabled" },
    ],
  },
];

const initialValuesForFilter = {
  datepicker: "",
  status: "enabled",
  line: "",
};

const CoinHistory = () => {
  const dispatch = useDispatch();
  const [showPicker, setShowPicker] = useState(false);

  const { coinHistoryList, coinHistoryLoading, coinHistoryCount } = useSelector(
    ({ Settings }) => Settings,
  );

  const { hasPermission } = usePermission();
  const permissions = hasPermission("view_coin_history");

  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 15,
    order: -1,
    orderBy: "line",
    status: "enabled",
    line: "",
    startDate: null,
    endDate: null,
  });

  const todayDate = moment().format("YYYY-MM-DD");

  const getApiData = (query) => {
    dispatch(
      getCoinHistoryList({
        data: {
          ...query,
          startDate: query.startDate || todayDate,
          endDate: query.endDate || todayDate,
        },
      }),
    );
  };

  useEffect(() => {
    getApiData(filter);
  }, [filter]);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setFilter((prevFilter) => ({
      ...prevFilter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setShowPicker(false);
  };

  // Setup columns
  useEffect(() => {
    setColumns(
      Columns().filter((item) => {
        if (item?.text === "Action" && !permissions.edit) {
          return false;
        }
        return true;
      }),
    );
  }, [permissions]);

  const handleFilterForm = (values) => {
    setFilter({
      ...filter,
      page: 1,
      status: values.status,
      line: values.line,
    });
  };

  return (
    <>
      <Helmet title="Coin History" />

      <section className="section">
        <div className="section-header">
          <h1>Coin History List</h1>
        </div>

        <div className="section-body">
          <div className="card">
            <div className="row">
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={coinHistoryLoading}
                    inputFields={InputFieldsForSearch}
                    buttonText="Search"
                    dateRange={filter}
                    showPicker={showPicker}
                    setShowPicker={setShowPicker}
                    handleSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
          </div>

          {coinHistoryLoading && (
            <div className="main-loader">
              <FadeLoader size={1000} />
            </div>
          )}

          {!coinHistoryLoading && coinHistoryList?.length > 0 && (
            <Table
              data={coinHistoryList}
              columns={columns}
              setFilter={setFilter}
              total={coinHistoryCount}
              filter={filter}
              // handleView={handleView}
            />
          )}

          {!coinHistoryLoading && coinHistoryList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Coin History Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default CoinHistory;
